import axios from 'lib/axios';

import {
  OAUTH_ERROR,
  OAUTH_LOADING,
  OAUTH_CLIENT_RECEIVED
} from 'constants/actions';

import { E_OAUTH_CLIENT_UNKNOWN, E_OAUTH_AUTH_UNKNOWN } from 'constants/errors';

import { dispatcher } from 'lib/redux';

export const getOauthClient = (clientId) => async () => {
  dispatcher(OAUTH_LOADING, true);

  try {
    const response = await axios.get(`oauth2/client?client_id=${clientId}`);

    dispatcher(OAUTH_LOADING, false);
    dispatcher(OAUTH_CLIENT_RECEIVED, response.data);
  } catch (e) {
    dispatcher(OAUTH_LOADING, false);

    if (e.canceled) return;

    if (e.response && e.response.data) {
      return dispatcher(OAUTH_ERROR, {
        type: e.response.data.type,
        message: e.response.data.message || E_OAUTH_CLIENT_UNKNOWN
      });
    }

    dispatcher(OAUTH_ERROR, E_OAUTH_CLIENT_UNKNOWN);
  }
};

export const authClient = (qs) => async () => {
  dispatcher(OAUTH_LOADING, true);

  try {
    const response = await axios.get(`oauth2/authorize${qs}`);
    dispatcher(OAUTH_LOADING, false);

    dispatcher(OAUTH_CLIENT_RECEIVED, {
      ...response.data.client,
      transactionId: response.data.transactionId
    });
  } catch (e) {
    dispatcher(OAUTH_LOADING, false);

    if (e.canceled) return;

    if (e.response && e.response.data) {
      return dispatcher(OAUTH_ERROR, e.response.data.message || E_OAUTH_AUTH_UNKNOWN);
    }

    dispatcher(OAUTH_ERROR, E_OAUTH_AUTH_UNKNOWN);
  }
};
